import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MaterialUICard from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { red } from '@material-ui/core/colors';

const useStyles = makeStyles({
  root: {
    width: '345px',
    marginLeft: '20px',
    marginRight: '20px',
    backgroundColor: 'rgb(255, 255, 255)'
  },
  media: {
    backgroundSize: 'contain',
    paddingTop: '56.25%', // 16:9
  },
  avatar: {
    backgroundColor: red[500]
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  }
});

const HomeCard = ({ title, text, button_text, button_hook }) => {
  const classes = useStyles();

  return (
    <MaterialUICard className={classes.root} raised={true}>
      <CardHeader
        title={title}
      />
      <CardContent>

        <Typography variant="body1" color="textSecondary" component="div">
            {text}
        </Typography>

        <Button
              variant="contained"
              color="primary"
              onClick={button_hook}
            >
              {button_text}
        </Button>

      </CardContent>
    </MaterialUICard>
  );
};


export default HomeCard;
